module.exports = __webpack_public_path__ + "static/damian-lg-20cda5ee1948e5ea187ab63fdc0a0d8f.jpg";